const {
  i18n: { __ },
  components: { ToolbarGroup, ToolbarButton },
  blockEditor: { BlockControls, store: blockEditorStore },
  data: { useDispatch, useSelect },
} = wp;

const ContainerToImage = ({ clientId, icon = 'format-image' }) => {
  const { replaceBlocks } = useDispatch(blockEditorStore);
  const innerBlocks = useSelect(
    (select) => select(blockEditorStore).getBlock(clientId).innerBlocks,
  );
  const desktopTabInnerBlocks = innerBlocks[0]?.innerBlocks;
  if (desktopTabInnerBlocks && desktopTabInnerBlocks.length > 0) {
    return (
      <BlockControls>
        <ToolbarGroup>
          <ToolbarButton
            icon={icon}
            label={__('Convert to a single image', 'b3rg')}
            onClick={() =>
              // Move the inner blocks out of the current block and remove the current block
              {
                replaceBlocks(clientId, desktopTabInnerBlocks);
              }
            }
          />
        </ToolbarGroup>
      </BlockControls>
    );
  }
};

export default ContainerToImage;
